<template>
  <swiper
    ref="swiper"
    class="screen-one-swiper"
    :options="swiperOptionOne"
  >
      <swiper-slide class="screen-one-swiper-item">
        <div class="swiper-slide-content">
          <img
                  class="represent-img"
                  src="../../assets/m_img_charge@2x.png"
                  data-swiper-parallax="-660"
          />
          <div
                  class="title-wrapper"
                  data-swiper-parallax="-300"
          >
            <div class="title__zh">新能源汽车充电</div>
            <div class="title__en">New energy vehicle charging</div>
          </div>
          <div
                  class="subtitle-wrapper"
                  data-swiper-parallax="-440"
          >
            <div class="subtitle">安全、快速充电</div>
            <div class="subtitle">全过程业务支撑</div>
          </div>
          <div
                  class="btn-group"
                  data-swiper-parallax="-560"
          >
            <!-- <Button @mouseenter="handleStopSwiper" @mouseleave="handleStartSwiper">我要成为大客户</Button>
            <Button @mouseenter="handleStopSwiper" @mouseleave="handleStartSwiper">我要投资</Button>
            <Button @mouseenter="handleStopSwiper" @mouseleave="handleStartSwiper">我要加盟</Button>-->

            <router-link
                    tag="span"
                    to="/keyCustomers"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
                      @click="goto('/keyCustomers')"
              >我要充电</Button>
            </router-link>
            <router-link
                    tag="span"
                    to="/chargingFranchise"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我要加盟</Button>
            </router-link>
            <router-link
                    tag="span"
                    to="/intelligentlogistics"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我要投资</Button>
            </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="screen-one-swiper-item">
        <div class="swiper-slide-content revert">
          <img
                  class="represent-img represent-img2"
                  src="@/assets/m_img_truck@2x.png"
                  data-swiper-parallax="-660"
          />
          <div
                  class="title-wrapper"
                  data-swiper-parallax="-300"
          >
            <div class="title__zh">智慧物流</div>
            <div class="title__en">intelligence logistics</div>
          </div>
          <div
                  class="subtitle-wrapper"
                  data-swiper-parallax="-440"
          >
            <div class="subtitle">智能运营、高效管理、资源共享</div>
            <div class="subtitle">一站式整体解决方案</div>
          </div>
          <div
                  class="btn-group"
                  data-swiper-parallax="-560"
          >
            <router-link
                    tag="span"
                    to="/parkServices"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我是园区管理员</Button>
            </router-link>
            <router-link
                    tag="span"
                    to="/transportationEnterprises"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我是运力企业</Button>
            </router-link>
            <router-link
                    tag="span"
                    to="/consignor"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我是货主</Button>
            </router-link>
            <router-link
                    tag="span"
                    to="/individualDriver"
            >
              <Button
                      @mouseenter="handleStopSwiper"
                      @mouseleave="handleStartSwiper"
              >我是司机</Button>
            </router-link>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="screen-one-swiper-item">
        <div class="swiper-slide-content">
          <img
                  class="represent-img"
                  src="@/assets/m_img_battery@2x.png"
                  data-swiper-parallax="-660"
          />
          <div
                  class="title-wrapper"
                  data-swiper-parallax="-300"
          >
            <div class="title__zh">换电储能</div>
            <div class="title__en">electric power storage</div>
          </div>
          <div
                  class="subtitle-wrapper"
                  data-swiper-parallax="-440"
          >
            <div class="subtitle">车电分离、分箱换电、动力电池循环利用</div>
            <div class="subtitle">打造“能源管家”服务</div>
          </div>
        </div>
      </swiper-slide>
    <div
      class="swiper-pagination swiper-pagination-white"
      id="swiper-pagination"
      slot="pagination"
    ></div>
  </swiper>
</template>

<script>
import Button from "@/components/button";

export default {
  components: {
    Button
  },

  data() {
    return {
      swiperRef: null,
      swiperOptionOne: {
        touchRatio: 0.8,
        speed: 800,
        parallax: true,
        pagination: {
          el: "#swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<div class="${className} full-swiper-pagination-custom-line"></div>`;
          }
        }
      }
    };
  },

  computed: {
    swiper() {
      return this.$refs.swiper.swiper;
    }
  },

  methods: {
    handleStartSwiper() {
      this.swiper.autoplay.start();
    },
    handleStopSwiper() {
      this.swiper.autoplay.stop();
    },
    goto(path){
      this.$router.push(path)
    }
  },

  mounted() {
    // this.handleStartSwiper();
    this.$bus.on("ScreenSlideTo-1");
  }
};
</script>
<style lang="less">
 @media screen and (min-width: 481px) {
   .mobile{
     display: none;
   }
   .pc-body{
      display: block;
    }

   .screen-one-swiper {
     color: @white;
     height: 100%;

     &-item {
       display: flex;
       align-items: center;
       justify-content: center;
     }

     .swiper-slide-content {
       position: relative;
       display: flex;
       flex-direction: column;
       margin-top: 82px;
       padding: 30px;
       width: 894px;
       height: 590px;

       &.revert {
         align-items: center;
         .title-wrapper,
         .subtitle-wrapper {
           text-align: right;
         }
         .represent-img {
           width: 672px;
           height: 540px;
           left: calc((100% - 672px) / 2);
           bottom: -60px;
         }
         .title__zh,.title__en,.subtitle{
           text-align: center;
         }
       }

       .title {
         &__zh {
           font-size: 36px;
           color: @white;
         }
         &__en {
           color: @text-primary;
           text-transform: uppercase;
         }
       }

       .subtitle {
         line-height: 2.5;
       }

       .btn-group {
         margin-top: 28px;
         span:not(:first-child) {
           margin-left: 20px;
         }
       }

       .represent-img {
         position: absolute;
         right: 0px;
         bottom: 0px;
         height: 540px;
       }
     }
   }
  }
 @media screen and (max-width: 480px) {
   .mobile{
     display: block;
   }
   .pc-body{
     display: none;
   }
   .screen-one-swiper {
     color: @white;
     height: 100%;

     &-item {
       display: flex;
       align-items: center;
       justify-content: center;
     }

     .swiper-slide-content {
       position: relative;
       display: flex;
       flex-direction: column;
       margin-top: 82px;
       padding: 30px;
       width: 894px;
       height: 590px;

       &.revert {
         align-items: center;
         .title-wrapper,
         .subtitle-wrapper {
           text-align: right;
         }
         .represent-img {
           width: 672px;
           height: 540px;
           /*left: calc((100% - 672px) / 2);*/
         }
         .title__zh,.title__en,.subtitle{
           text-align: center;
         }
       }

       .title {
         &__zh {
           font-size: 36px;
           color: @white;
         }
         &__en {
           color: @text-primary;
           text-transform: uppercase;
         }
       }

       .subtitle {
         line-height: 2.5;
       }

       .btn-group {
         margin-top: 28px;
         span:not(:first-child) {
           margin-left: 20px;
         }
       }

       .represent-img {
         position: absolute;
         right: 0px;
         bottom: 0px;
         height: 540px;
       }
     }
   }
    .screen-one-swiper .swiper-slide-content .title__zh{
      text-align: center;
    }
    .screen-one-swiper .swiper-slide-content .title__en{
      text-align: center;
    }
    .screen-one-swiper .swiper-slide-content .subtitle{
      text-align: center;
    }
    .screen-one-swiper .swiper-slide-content .represent-img {
      right:calc((100% - 375px)/2)!important;
      bottom: 30px!important;
      margin: 0 auto;
      height: 300px!important;
      width: 375px!important;
    }
    .screen-one-swiper .swiper-slide-content .represent-img2 {
      bottom: -8px!important;
    }
    .btn-group{
      text-align: center;
    }
    .btn-group span:not(:first-child){
      margin-left:0!important;
    }
    .btn-group span{
      display: block;
      margin-bottom: 10px;
    }
  }
</style>
